import { useCookies } from "react-cookie";

export function SessionExpired({}) {
  const [cookies, setCookie, removeCookie] = useCookies("");

  const handleLogin = () => {
    const cookieOptions = {
      domain: process.env.REACT_APP_COMMON_DOMAIN,
      path: "/",
    };
    removeCookie("refreshTokenAC", cookieOptions);
    localStorage.clear();
    const redirectUri = process.env.REACT_APP_REDIRECTURI;
    const clientId = process.env.REACT_APP_CLIENTID;
    const scope = process.env.REACT_APP_SCOPE;
    const accesstype = process.env.REACT_APP_ACCESS_TYPE;
    const prompt = process.env.REACT_APP_PROMPT;
    const authUrl =
      process.env.REACT_APP_AUTHURL +
      `?response_type=code&client_id=${clientId}&redirect_uri=${redirectUri}&scope=${scope}&access_type=${accesstype}&prompt=${"consent"}`;
    window.location.href = authUrl;
  };

  // const handleLogin = () => {
  //     localStorage.clear();
  //     window.location.pathname = "/";
  // }

  return (
    <>
      <div className="text-center">
        <p className="mb-12 usernotfound">
          Your session has expired, Please Login again.
        </p>
        <p
          className="cursor-pointer a-tag text-decoration"
          onClick={handleLogin}
        >
          Go to Login
        </p>
      </div>
    </>
  );
}
